export default __webpack_public_path__ + "06d50d376e97d885ddaf9454133a0712.svg";